import React, { useEffect, useRef, useState } from "react";
// import { useLocation } from "react-router-dom";
import {
  RiArrowDropDownLine,
  RiArrowDropRightLine,
  RiCloseLine,
} from "react-icons/ri";
import images from "../../constant/images";
import "./nav.css";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useSelector } from "react-redux";
import { storeToken, updateLang } from "../../formSlice";
import { useDispatch } from "react-redux";
import { BiUser } from "react-icons/bi";
import { IoMdArrowDropright } from "react-icons/io";
import { FiLogOut } from "react-icons/fi";

export const Nav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const language = localStorage.getItem("i18nextLng");

  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (dropdownId) => {
    setOpenDropdown(openDropdown === dropdownId ? null : dropdownId);
  };

  const local = useLocation();
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("lang", lng);
    dispatch(updateLang(lng));
  };

  const activePaths = [
    "/GTMclub/2026Program",
    "/GTMclub/tournois/gtmIconic",
    "/GTMclub/tournois/industry",
    "/GTMclub/strategies/2daySummit",
    "/GTMclub/Golf&LinkingUp",
    "/GTMclub/business/cultures",
    "/membership/welcome",
    "/membership/profile",
    "/membership/members",
    "/membership/paiments",
    "/membership/notification",
    "/trips/inbound",
    "/trips/outbound",
  ];
  const isActive = activePaths.includes(location.pathname);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [openApropos, setOpenApropos] = useState(false);
  const [openGtmClub, setOpenGtmClub] = useState(false);
  const [openBusiness, setOpenBusiness] = useState(false);
  const [openTournois, setOpenTournois] = useState(false);
  const [openActualites, setOpenActualites] = useState(false);
  const [openTrips, setOpenTrips] = useState(false);
  const [openMedia, setOpenMedia] = useState(false);
  const [openRanking, setOpenRanking] = useState(false);
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [user, setUser] = useState();
  const [membership, setMembership] = useState(null);
  const profile = useSelector((state) => state.gtm.profile);
  const [pack, setPack] = useState(null);
  const [error, setError] = useState(null);
  const [membresh, setMembresh] = useState(false);
  const [pages, setPages] = useState([]);
  const lang = useSelector((state) => state.gtm.lang);
  const [inboundTrips, setInboundTrips] = useState([]);
  const [outboundTrips, setOutboundTrips] = useState([]);

  const localStorageUser = localStorage.getItem("user");
  const token = localStorage.getItem("userToken");
  const [isLoading, setIsLoading] = useState(true);
  const [time, setTime] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
    localTimeString: "00:00",
    gmtTimeString: "00:00",
  });

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const hours = now.getUTCHours() % 12;
      const minutes = now.getUTCMinutes();
      const seconds = now.getUTCSeconds();
      const localHours = now.getHours().toString().padStart(2, "0");
      const localMinutes = now.getMinutes().toString().padStart(2, "0");
      const localTimeString = `${localHours}:${localMinutes}`;
      const gmtHours = now.getUTCHours().toString().padStart(2, "0");
      const gmtMinutes = now.getUTCMinutes().toString().padStart(2, "0");
      const gmtTimeString = `${gmtHours}:${gmtMinutes}`;
      setTime({
        hours,
        minutes,
        seconds,
        localTimeString,
        gmtTimeString,
      });
    };
    updateClock();
    const intervalId = setInterval(updateClock, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const hourDegrees = time.hours * 30;
  const minuteDegrees = time.minutes * 6;
  const secondDegrees = time.seconds * 6;

  const fetchData = async () => {
    try {
      if (token) {
        const response = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
        setMembership(response.data?.membership);

        if (response.data?.membership?.status.trim() === "valid") {
          setPack(response.data.membership?.membership_packs);
        }
        dispatch(storeToken(token));
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const platform = "web";

        const response = await axios.get(`${baseUrl}/pages`, {
          params: {
            lang: lang,
            platform: platform,
          },
        });

        setPages(response.data.pages);
      } catch (error) {
        console.error("Error fetching pages:", error);
      }
    };

    fetchPages();
  }, [lang]);

  // Fetch trips for navigation links
  useEffect(() => {
    const fetchTrips = async () => {
      try {
        const [inboundResponse, outboundResponse] = await Promise.all([
          axios.get(`${baseUrl}/trips/inbound`).catch(() => ({ data: { success: false, data: [] } })),
          axios.get(`${baseUrl}/trips/outbound`).catch(() => ({ data: { success: false, data: [] } }))
        ]);

        if (inboundResponse.data.success && inboundResponse.data.data) {
          setInboundTrips(inboundResponse.data.data);
        }

        if (outboundResponse.data.success && outboundResponse.data.data) {
          setOutboundTrips(outboundResponse.data.data);
        }
      } catch (error) {
        console.error("Error fetching trips:", error);
        // Silently fail - trips menu items just won't show sub-items
      }
    };

    fetchTrips();
  }, [baseUrl]);

  // Toggle functions:
  const toggleMobileMenu = () => {
    setMobileOpen(!mobileOpen);
    document.body.classList.toggle("no-scroll", !mobileOpen);
  };

  const toggleGtmClub = () => {
    setOpenGtmClub(!openGtmClub);
  };
  const toggleMembreship = () => {
    setMembresh(!membresh);
  };

  const toggleActualites = () => {
    setOpenActualites(!openActualites);
  };

  const toggleTrips = () => {
    setOpenTrips(!openTrips);
  };

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const getimages = (packType) => {
    if (packType) {
      return membership?.membership_packs?.profile;
    }

    if (user?.free_pack === 1) {
      return images.Frame;
    }

    return images.visiteur;
  };
  const imagess = getimages(membership?.membership_packs?.profile);
  const getimages2 = (packType) => {
    const normalizedPack = String(packType).toLowerCase().trim();

    const imagesMap = {
      "non-golfer": images.bronze_menu,
      golfer: images.gold_menu,
      "golfer+": images.platinum_menu,
      default: images.menu_visit,
    };

    return imagesMap[normalizedPack] || imagesMap.default;
  };
  const imagess2 = getimages2(membership?.membership_packs?.name);

  const getimages3 = (packType) => {
    const normalizedPack = String(packType).toLowerCase().trim();

    const imagesMap = {
      "non-golfer": images.bronz,
      golfer: images.goldd,
      "golfer+": images.platin,
      default: images.logo,
    };

    return imagesMap[normalizedPack] || imagesMap.default;
  };
  const imagess3 = getimages3(membership?.membership_packs?.name);

  const packGradients = {
    "non-golfer": {
      colors: ["#441903", "#FF6F3F", "#FFA47F", "#CA5730", "#442525"],
      locations: [0, 0.25, 0.5, 0.75, 1.0],
    },
    golfer: {
      colors: [
        "#884F00",
        "#8E5709",
        "#9D6B21",
        "#B68C49",
        "#D8BA80",
        "#FFEFBF",
        "#DDC28D",
        "#C19C62",
        "#A97C3F",
        "#976423",
        "#895210",
        "#824704",
        "#7F4400",
      ],
      locations: [
        0.01, 0.06, 0.15, 0.25, 0.38, 0.51, 0.58, 0.65, 0.72, 0.79, 0.86, 0.93,
        1.0,
      ],
    },
    "golfer+": {
      colors: [
        "#5C5C5C",
        "#6C6C6C",
        "#A5A5A5",
        "#BCBCBC",
        "#D6D6D6",
        "#C1C1C1",
        "#8A8A8A",
        "#474747",
      ],
      locations: [0, 0.02, 0.11, 0.15, 0.49, 0.53, 0.79, 1.0],
    },
    default: {
      colors: ["#00573f", "#00573f"],
      locations: [0, 0.5],
    },
  };

  const getimagess2 = (packType) => {
    if (packType) {
      return `${membership?.membership_packs?.color}`;
    }

    return "#00573f";
  };
  const imagess22 = getimagess2(membership?.membership_packs?.color);

  function getGradientStyle(pack) {
    const gradientConfig = packGradients[pack] || packGradients.default;

    const colorStops = gradientConfig.colors
      ?.map(
        (color, index) => `${color} ${gradientConfig.locations[index] * 100}%`
      )
      .join(", ");

    return `linear-gradient(90deg, ${colorStops})`;
  }

  const logout = async () => {
    const token = localStorage.getItem("userToken");

    if (!token) {
      return navigate("/login");
    }

    try {
      await axios.post(
        `${baseUrl}/logout`,
        {
          withCredentials: true,
          withXSRFToken: true,
          credentials: "include",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      localStorage.removeItem("userToken");
      localStorage.removeItem("user");

      dispatch(storeToken(null));

      navigate("/login");
    }
  };

  // const getHoverClass = (packType) => {
  //   const normalizedPack = String(packType).toLowerCase().trim();

  //   const hoverClasses = {
  //     "non-golfer": "hover:text-[#FF6F3F] group-hover:text-[#FF6F3F]",
  //     golfer: "hover:text-[#884F00] group-hover:text-[#884F00]",
  //     "golfer+": "hover:text-[#5C5C5C] group-hover:text-[#5C5C5C]",
  //     "defafree membershipult":
  //       "hover:text-[#00573f] group-hover:text-[#00573f]",
  //     default: "hover:text-[#fff] group-hover:text-[#fff]",
  //   };

  //   return hoverClasses[normalizedPack] || hoverClasses.default;
  // };
  // const hoverClass = getHoverClass(membership?.membership_packs?.name);

  const getimagess = (packType) => {
    if (packType) {
      return `${membership?.membership_packs?.bars}`;
    }

    return images.menu_visit;
  };
  const imagesMenu = getimagess(membership?.membership_packs?.bars);

  const sidebarRef = useRef(null);
  const closeTimeoutRef = useRef(null);

  const bodyRef = useRef(document.body);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        closeSidebar();
      }
    };

    if (mobileOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      bodyRef.current.style.overflow = "hidden";
    } else {
      bodyRef.current.style.overflow = "auto";
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      bodyRef.current.style.overflow = "auto";
    };
  }, [mobileOpen]);

  const closeSidebar = () => {
    setMobileOpen(false);
    bodyRef.current.style.overflow = "auto";
  };

  const isActive2 = (path) => local.pathname === path;
  const [hoveredItem, setHoveredItem] = useState(null);
  const handleHover = (itemId) => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    setHoveredItem(itemId);
  };

  const handleHoverLeave = () => {
    closeTimeoutRef.current = setTimeout(() => {
      setHoveredItem(null);
    }, 150);
  };

  return (
    <nav className="w-full flex flex-col gap-2">
      <div className="flex items-center block custom:hidden  justify-between p-4 text-white bg-black">
        {/* logo */}
        <NavLink to="/home" className="block custom:hidden z-50">
          <img
            className="w-[60px] h-[70px] overflow-visible"
            src={images.gtm_rolex}
            alt="Logo GTM"
          />
        </NavLink>

        <button className="menu-btn custom:hidden " onClick={toggleMobileMenu}>
          {mobileOpen ? (
            <RiCloseLine
              size={28}
              style={{
                color: membership?.membership_packs?.color,
              }}
            />
          ) : (
            <img src={imagesMenu} width={40} className="" alt="" />
          )}
        </button>
      </div>
      {/* NEW COMBINED NAVBAR */}
      <div className="w-full px-[5rem] custom4:px-[6rem] screen hidden custom:flex justify-center">
        <div className="flex flex-col items-end w-fit gap-2">
          {/* Flags and Login Section */}
          <div className="flex items-center justify-end gap-4 pb-3 pt-4">
            <p
              className="flex items-center gap-1 cursor-pointer hover:opacity-50"
              onClick={() => changeLanguage("fr")}
            >
              <img width={20} src={images.france_logo} alt="" />
              <span
                className="text-white font-semibold"
                style={{
                  textShadow: "2px 0px 5px #000",
                  fontWeight: "700",
                }}
              >
                Francais
              </span>
            </p>
            <p
              className="flex items-center gap-1 cursor-pointer hover:opacity-50"
              onClick={() => changeLanguage("en")}
            >
              <img width={20} src={images.usa_logo} alt="" />
              <span
                className="text-white font-semibold"
                style={{
                  textShadow: "2px 0px 5px #000",
                  fontWeight: "700",
                }}
              >
                English
              </span>
            </p>
            {!localStorageUser ? (
              <div>
                <NavLink to="/login">
                  <button className="font-bold hover:opacity-75 text-white bg-[#00573f] px-10 py-1 text-[18px] rounded-full">
                    Login
                  </button>
                </NavLink>
              </div>
            ) : (
              <div>
                <NavLink to="/membership/profile">
                  <button className="font-bold flex gap-2 items-center text-[#00573f] bg-white border border-[#00573f] px-6 py-1 text-[18px] rounded-full">
                    <BiUser className={`h-6 w-6 text-[#00573f] font-bold`} />
                    {language === "fr" ? "Mon profil" : "My profile"}
                  </button>
                </NavLink>
              </div>
            )}
          </div>

          {/* Combined Bar */}
          <div className="flex items-center bg-[#00573f] rounded-full shadow-[5px_3px_15px_rgba(0,0,0,0.4)] px-8 h-[75px] gap-8">
            {/* Logo */}
            <NavLink to="/home" className="flex items-center">
              <img
                className="overflow-visible"
                width={80}
                src={images.gtm_rolex}
                alt="Logo GTM"
              />
            </NavLink>

            {/* Nav Links */}
            <ul className="flex items-center gap-8 text-white h-full pe-8 border-e border-white/20">
              <li
                className={`hover text-[1rem] relative h-full flex items-center ${
                  isActive ? "active text-nav_gold" : ""
                }`}
                onMouseEnter={() => handleHover('gtmClub')}
                onMouseLeave={handleHoverLeave}
              >
                  <NavLink
                    to="#"
                    className={`flex items-center justify-center whitespace-nowrap hover_miss`}
                  >
                    {t("navbar.gtmClub")}
                    <div className={`text-2xl transition-transform duration-300 ${hoveredItem === 'gtmClub' ? 'rotate-180' : ''}`}>
                      <RiArrowDropDownLine />
                    </div>
                  </NavLink>
                  <div className={`absolute left-0 top-full w-60 z-50 origin-top-left bg-white divide-y divide-gray-100 shadow-lg transition duration-300 ${hoveredItem === 'gtmClub' ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
                    <div className="">
                      <div className="relative group/Networking">
                        <NavLink
                          to="/GTMclub/Golf&LinkingUp"
                          className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss ${
                            location.pathname === "/GTMclub/Golf&LinkingUp" ||
                            location.pathname === "/GTMclub/business/cultures" ||
                            location.pathname === "/GTMclub/strategies/2daySummit"
                              ? "text-nav_gold font-bold"
                              : ""
                          }`}
                        >
                          Business
                          <RiArrowDropRightLine className="text-lg" />
                        </NavLink>
                        <div className="absolute left-0 w-full h-5"></div>
                        <div className="absolute left-[100%] top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/Networking:opacity-100 group-hover/Networking:visible transition duration-300">
                          <NavLink
                            to="/GTMclub/business/cultures"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                              location.pathname === "/GTMclub/business/cultures"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            {t("navbar.gtm_Club.busines_sub.b_c")}
                          </NavLink>
                          <NavLink
                            to="/GTMclub/strategies/2daySummit"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                              location.pathname === "/GTMclub/strategies/2daySummit"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            {t("navbar.gtm_Club.summit_sub.day_summit")}
                          </NavLink>
                        </div>
                      </div>

                      <div className="relative group/tournois">
                        <NavLink
                          to="#"
                          className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss ${
                            location.pathname === "/GTMclub/tournois/gtmIconic" ||
                            location.pathname === "/GTMclub/tournois/industry" ||
                            location.pathname === "/GTMclub/tournois/Initiation"
                              ? "text-nav_gold font-bold"
                              : ""
                          }`}
                        >
                          Golf
                          <RiArrowDropRightLine className="text-lg" />
                        </NavLink>
                        <div className="absolute left-full top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/tournois:opacity-100 group-hover/tournois:visible transition duration-300">
                          <NavLink
                            to="/GTMclub/tournois/gtmIconic"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-gray-300 hover_miss ${
                              location.pathname === "/GTMclub/tournois/gtmIconic"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            {t("navbar.gtm_Club.tournaments_sub.gtm_ionic")}
                          </NavLink>
                          <NavLink
                            to="/GTMclub/tournois/industry"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-gray-300 hover_miss ${
                              location.pathname === "/GTMclub/tournois/industry"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            {t("navbar.gtm_Club.tournaments_sub.industry")}
                          </NavLink>
                          <NavLink
                            to="/GTMclub/tournois/Initiation"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-gray-300 hover_miss ${
                              location.pathname === "/GTMclub/tournois/Initiation"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            Initiation
                          </NavLink>
                        </div>
                      </div>

                      <div className="relative group/Strategies">
                        <NavLink
                          to="#"
                          className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss ${
                            location.pathname === "/lifestyle/arts" ||
                            location.pathname === "/lifestyle/bigsmoke" ||
                            location.pathname === "/lifestyle/rando-adventure"
                              ? "text-nav_gold font-bold"
                              : ""
                          }`}
                        >
                          Lifestyle
                          <RiArrowDropRightLine className="text-lg" />
                        </NavLink>
                        <div className="absolute left-full top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/Strategies:opacity-100 group-hover/Strategies:visible transition duration-300">
                          <NavLink
                            to="/lifestyle/arts"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                              location.pathname === "/lifestyle/arts"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            Art
                          </NavLink>
                          <NavLink
                            to="/lifestyle/bigsmoke"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                              location.pathname === "/lifestyle/bigsmoke"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            Big Smoke
                          </NavLink>
                          <NavLink
                            to="/lifestyle/rando-adventure"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                              location.pathname === "/lifestyle/rando-adventure"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            Off-Road Adventure
                          </NavLink>
                        </div>
                      </div>

                      <div className="relative group/Trips">
                        <NavLink
                          to="/trips"
                          className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss ${
                            location.pathname === "/trips" ||
                            location.pathname === "/trips/inbound" ||
                            location.pathname === "/trips/outbound"
                              ? "text-nav_gold font-bold"
                              : ""
                          }`}
                        >
                          {t("navbar.trips")}
                          <RiArrowDropRightLine className="text-lg" />
                        </NavLink>
                        <div className="absolute left-full top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/Trips:opacity-100 group-hover/Trips:visible transition duration-300">
                          <NavLink
                            to="/trips/inbound"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                              location.pathname === "/trips/inbound"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            {t("navbar.trips_sub.inbound")}
                          </NavLink>
                          <NavLink
                            to="/trips/outbound"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                              location.pathname === "/trips/outbound"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            {t("navbar.trips_sub.outbound")}
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
              </li>

              <li
                className={`hover text-[1rem] relative ${
                  location.pathname === "/gtmclub/2026program" ? "text-nav_gold font-bold" : ""
                }`}
              >
                <NavLink to="/gtmclub/2026program" className="whitespace-nowrap hover_miss">
                  {t("navbar.calendar")}
                </NavLink>
              </li>

              <li
                className={`hover text-[1rem] relative h-full flex items-center ${
                  location.pathname === "/apropos" ? "text-nav_gold font-bold" : ""
                }`}
                onMouseEnter={() => handleHover('aboutUs')}
                onMouseLeave={handleHoverLeave}
              >
                  <button type="button" className="flex items-center justify-center">
                    <NavLink to="/apropos" className="whitespace-nowrap hover_miss">
                      {t("navbar.aboutUs")}
                    </NavLink>
                    <div className={`text-2xl transition-transform duration-300 ${hoveredItem === 'aboutUs' ? 'rotate-180' : ''}`}>
                      <RiArrowDropDownLine />
                    </div>
                  </button>
                  <div className={`absolute left-0 top-full w-56 z-50 origin-top-left bg-white divide-y divide-gray-100 shadow-lg transition duration-300 ${hoveredItem === 'aboutUs' ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
                    <div className="">
                      <NavLink
                        to="/apropos#Mission"
                        className="block whitespace-nowrap px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 hover_miss"
                      >
                        {t("navbar.about_Us.mission")}
                      </NavLink>
                      <NavLink
                        to="/apropos#Temoignages"
                        className="block whitespace-nowrap px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 hover_miss"
                      >
                        {t("navbar.about_Us.testimonials")}
                      </NavLink>
                      <div className="relative group/Medias">
                        <NavLink
                          to="#"
                          className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss ${
                            location.pathname === "/actualites/media/presse" ||
                            location.pathname === "/actualites/media/blog"
                              ? "text-nav_gold font-bold"
                              : ""
                          }`}
                        >
                          {t("navbar.news_sub.media")}
                          <RiArrowDropRightLine className="text-lg" />
                        </NavLink>
                        <div className="absolute left-full top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/Medias:opacity-100 group-hover/Medias:visible transition duration-300">
                          <NavLink
                            to="/actualites/media/presse"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 hover_miss ${
                              location.pathname === "/actualites/media/presse"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            {t("navbar.news_sub.media_sub.press")}
                          </NavLink>
                          <NavLink
                            to="/actualites/media/blog"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                              location.pathname === "/actualites/media/blog"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            {t("navbar.news_sub.media_sub.blog")}
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
              </li>
            </ul>

            {/* Rolex Clock Section */}
            <div className="flex items-center gap-4 text-white">
              {/* Rolex Logo */}
              <div className="w-[80px] h-auto">
                <svg id="rolex-logo" viewBox="0 0 266.7 156.1">
                  <g>
                    <g>
                      <g>
                        <path
                          fill="#c0911e"
                          d="M103.1,34.2c0.4,0,0.7-0.1,1.1-0.1l12.7,43.2h0c1.4,4.8,8.4,8.5,16.9,8.5c8.5,0,15.5-3.7,16.9-8.5h0
                          l12.7-43.2c0.3,0.1,0.6,0.1,1,0.1c2.5,0,4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5c0,1.8,1,3.3,2.5,4l-14.7,31.6
                          l2.4-42.5c0,0,0.1,0,0.1,0c2.5,0,4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5c0,2,1.4,3.7,3.2,4.3l-9.8,41.6
                          l-4.7-45.8c2.2-0.3,3.8-2.2,3.8-4.4c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5c0,2.3,1.7,4.1,3.9,4.4l-4.7,45.7l-9.8-41.5
                          c1.9-0.5,3.3-2.2,3.3-4.3c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5c0,2.5,2,4.5,4.5,4.5c0,0,0,0,0.1,0l2.4,42.5l-14.7-31.6
                          c1.4-0.7,2.4-2.2,2.4-4c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5C98.6,32.2,100.6,34.2,103.1,34.2z M133.7,73.6
                          c7.7,0,14,2,14,4.4c0,2.4-6.3,4.4-14,4.4c-7.7,0-14-2-14-4.4C119.7,75.6,126,73.6,133.7,73.6z"
                        />
                        <g>
                          <path
                            fill="#FFFFFF"
                            d="M84.4,103.8c-12.8,0-23.2,10.4-23.2,22.9c0,12.5,10.4,22.9,23.2,22.9c12.8,0,23.2-10.4,23.2-22.9
                            C107.6,114.2,97.2,103.8,84.4,103.8z M94,139.9c-0.7,1.1-1.6,2-2.7,2.8c-1.7,1.4-3.7,2.2-5.8,2.2c-0.4,0-0.8,0.1-1.2,0.1
                            c-0.4,0-0.8,0-1.2-0.1c-2.1-0.1-4-0.9-5.7-2.2c-1.1-0.8-2-1.7-2.7-2.8c-2.4-3.3-3.9-8-3.9-13.2c0-4.9,1.3-9.3,3.5-12.5
                            c1.2-2.2,3.1-3.9,5.4-4.9c0,0,0,0,0.1,0c0.1,0,0.2-0.1,0.3-0.1c0.3-0.1,0.6-0.2,0.9-0.3c1.1-0.3,2.2-0.5,3.3-0.5
                            c1.2,0,2.3,0.2,3.3,0.5c0.3,0.1,0.6,0.2,0.9,0.3c0.1,0,0.2,0.1,0.3,0.1c0,0,0,0,0.1,0c2.3,1,4.2,2.7,5.4,4.9
                            c2.2,3.3,3.5,7.7,3.5,12.5C97.9,131.9,96.4,136.6,94,139.9z"
                          />
                          <path
                            fill="#FFFFFF"
                            d="M153.5,131.5h-3.2v6.4c-0.1,3.9-3.2,7-7.1,7c0,0,0,0,0,0v0h-9.8h-3.7v-36.3h6.2v-3.2h-6.2l0,0h-0.7h-15.5
                            v3.2h6.2v36.3h-6.2v3.2h36.9h2.7h0.3h0.2v0h0v-10.5h0V131.5z"
                          />
                          <path
                            fill="#FFFFFF"
                            d="M202.5,105.5L202.5,105.5h-0.3h-9.9h-32v3.2h6.1v36.3h-6.1v3.2v0h32h7.2h2.8h0.2h0h0.2v-10.5v-4.8h-3.2v5.1
                            l0,0c0,3.9-3.2,7.1-7.1,7.1c0,0,0,0,0,0v0h-11.5v0h-4.3h-0.1v-17.4V127h3.2c0,0,0.1,0,0.1,0h1.8l0,0c2.9,0,5.2,2.4,5.2,5.3
                            c0,0,0,0.1,0,0.1h0v1.7l0,0v0.7h2.9v-0.4V127v0v-2.6v0V117v-0.1h-2.9v2.1h0c0,0,0,0.1,0,0.1c0,2.9-2.3,5-5.2,5l0,0h-1.9h-2h-1.2
                            v-15.3h0.1h9.2c0,0,0.1,0,0.1,0h6.6c3.9,0,7.1,3.2,7.1,7.1l0,0v4.4h3.2V116v-10.5v0H202.5z"
                          />
                          <path
                            fill="#FFFFFF"
                            d="M257.9,145.1c-3.1-0.1-3.8-1-6.2-3.8l-14.1-17.6l9.4-11.2v0c2.5-2.9,3.2-3.9,6.4-3.9h2h0.4v-3.1h-0.4h-9.2
                            h-0.4H239h-0.4v3.1h0.4h3.4v0c0,0,0,0,0,0c0.8,0,1.5,0.6,1.5,1.5c0,0.3-0.1,0.6-0.3,0.9l-8.3,9.9l-6.5-8.1l-1.4-1.7
                            c-0.2-0.3-0.3-0.6-0.3-0.9c0-0.8,0.7-1.5,1.5-1.5h3.7v-3.1h-6.6H216h-5.3v3.1h1c2.8,0.1,3.5,1.1,5.7,3.5l12.5,15.6l-11.3,13.5v0
                            c-2.5,2.9-3.2,3.9-6.4,3.9h-2h-0.7v3.1h0.7h10.7h0.7h5.8h0.7v-3.1h-0.7h-3.9v0c0,0,0,0,0,0c-0.8,0-1.5-0.6-1.5-1.5
                            c0-0.3,0.1-0.7,0.3-0.9l10-11.9l8.3,10.4l1.3,1.6c0.2,0.3,0.3,0.6,0.3,0.9c0,0.8-0.7,1.5-1.5,1.5c0,0,0,0,0,0l0,0h-4v3.1h0v0
                            H260v-3.1H257.9z"
                          />
                        </g>
                      </g>
                    </g>
                    <path
                      fill="#FFFFFF"
                      d="M53.9,144.9l-2.8-8.2c-1.3-3.7-2.3-5.3-4.3-7.2c-1.4-1.2-3.3-1.8-4.7-2.2c5.3-0.8,9.3-5.4,9.3-10.9
                      c0-6.1-4.9-11-11-11c-0.1,0-0.1,0-0.2,0v0H23.5h-10h-6v3.2h6v36.3H7.4v3.2h16l0,0h6.2v-3.2h-6.1v-17.4h4.8c0.2,0,0.3,0,0.4,0h1
                      c1.5,0.1,2.8,0.3,4,0.6c1.1,0.3,2.3,0.7,3,1.2c1.1,0.7,2.2,1.6,3.2,3.3c0.3,0.4,0.5,0.9,0.7,1.3c1.8,3.4,2.9,8.2,4.1,14.2h7.3v0
                      h6.6v-3.2H53.9z M33.9,124.2H23.5v-15.6h10.4c4.5,0.2,8.1,3.3,8.1,7.8C42,120.9,38.4,124,33.9,124.2z"
                    />
                  </g>
                </svg>
              </div>

              {/* Clock Face */}
              <div className="relative w-[50px] h-[50px]">
                <img
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/80-N3AScM813m2lgFdijDUWXihbgWsZ5j.png"
                  alt="Rolex Watch Face"
                  className="absolute top-0 left-0 w-full h-full"
                />
                <div
                  className="absolute bottom-1/2 left-1/2 w-[2px] h-[12px] bg-[#0f3c03] rounded-sm z-10 origin-bottom"
                  style={{ transform: `translateX(-50%) rotate(${hourDegrees}deg)` }}
                ></div>
                <div
                  className="absolute bottom-1/2 left-1/2 w-[1.5px] h-[18px] bg-[#0f3c03] rounded-sm z-10 origin-bottom"
                  style={{ transform: `translateX(-50%) rotate(${minuteDegrees}deg)` }}
                ></div>
                <div
                  className="absolute bottom-1/2 left-1/2 w-[1px] h-[22px] bg-nav_gold rounded-sm z-10 origin-bottom"
                  style={{ transform: `translateX(-50%) rotate(${secondDegrees}deg)` }}
                ></div>
              </div>

              {/* Time Display */}
              <div className="flex flex-col text-[11px] items-center justify-center self-center">
                <div className="flex flex-col items-center leading-tight">
                  <span className="font-bold text-nav_gold">GMT</span>
                  <span className="font-bold text-nav_gold">{time.gmtTimeString}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ORIGINAL DESKTOP NAVBAR (COMMENTED OUT) - Preserved as a copy as requested */}
      {/* 
      <div className=" px-[5rem] custom4:px-[6rem] screen  hidden custom:block">
        <div className="flex flex-col items-center gap-2 ">
          <div className="flex items-end justify-between">
            <ul className="nav  flex items-center h-[75px] justify-center gap-8 pe-6 text-white relative">
              <li className="flex items-center justify-center">
                <NavLink to="/home">
                  <img
                    className=" overflow-visible"
                    width={90}
                    src={images.gtm_rolex}
                    alt="Logo GTM"
                  />
                </NavLink>
              </li>
              <div className="flex gap-[3.7rem] z-[99999]">
                <li className={`hover text-[1rem] relative`}>
                  <div className="group">
                    <NavLink to="#" className={`flex items-center justify-center whitespace-nowrap hover_miss`}>
                      {t("navbar.gtmClub")}
                      <div className="text-2xl transition-transform duration-300 hover-miss group-hover:rotate-180">
                        <RiArrowDropDownLine />
                      </div>
                    </NavLink>
                    <div className="absolute left-0 w-full h-6"></div>
                    <div className="absolute left-0 mt-6 w-60 origin-top-left bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition duration-300">
                      <div className="">
                        <div className="relative group/Networking">
                          <NavLink to="/GTMclub/Golf&LinkingUp" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss`}>
                            Business
                            <RiArrowDropRightLine className="text-lg" />
                          </NavLink>
                          <div className="absolute left-0 w-full h-5"></div>
                          <div className="absolute left-[100%] top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/Networking:opacity-100 group-hover/Networking:visible transition duration-300">
                            <NavLink to="/GTMclub/business/cultures" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss`}>
                              {t("navbar.gtm_Club.busines_sub.b_c")}
                            </NavLink>
                            <NavLink to="/GTMclub/strategies/2daySummit" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss`}>
                              {t("navbar.gtm_Club.summit_sub.day_summit")}
                            </NavLink>
                          </div>
                        </div>

                        <div className="relative group/tournois">
                          <NavLink to="#" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss`}>
                            Golf
                            <RiArrowDropRightLine className="text-lg" />
                          </NavLink>
                          <div className="absolute left-full top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/tournois:opacity-100 group-hover/tournois:visible transition duration-300">
                            <NavLink to="/GTMclub/tournois/gtmIconic" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-gray-300 hover_miss`}>
                              {t("navbar.gtm_Club.tournaments_sub.gtm_ionic")}
                            </NavLink>
                            <NavLink to="/GTMclub/tournois/industry" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-gray-300 hover_miss`}>
                              {t("navbar.gtm_Club.tournaments_sub.industry")}
                            </NavLink>
                            <NavLink to="/GTMclub/tournois/Initiation" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-gray-300 hover_miss`}>
                              Initiation
                            </NavLink>
                          </div>
                        </div>

                        <div className="relative group/Strategies">
                          <NavLink to="#" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss`}>
                            Lifestyle
                            <RiArrowDropRightLine className="text-lg" />
                          </NavLink>
                          <div className="absolute left-full top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/Strategies:opacity-100 group-hover/Strategies:visible transition duration-300">
                            <NavLink to="/lifestyle/arts" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss`}>
                              Art
                            </NavLink>
                            <NavLink to="/lifestyle/bigsmoke" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss`}>
                              Big Smoke
                            </NavLink>
                            <NavLink to="/lifestyle/rando-adventure" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss`}>
                              Rando - Adventure
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li className={`hover text-[1rem] relative`}>
                  <div className="group">
                    <button type="button" className="flex items-center justify-center">
                      <NavLink to="/apropos" className="whitespace-nowrap hover_miss">
                        {t("navbar.aboutUs")}
                      </NavLink>
                      <div className="text-2xl transition-transform duration-300 group-hover:rotate-180">
                        <RiArrowDropDownLine />
                      </div>
                    </button>
                    <div className="absolute left-0 w-full h-6"></div>
                    <div className="absolute left-0 mt-6 w-56 origin-top-left bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition duration-300">
                      <div className="">
                        <NavLink to="/apropos#Mission" className="block whitespace-nowrap px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 hover_miss">
                          {t("navbar.about_Us.mission")}
                        </NavLink>
                        <NavLink to="/apropos#Temoignages" className="block whitespace-nowrap px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 hover_miss">
                          {t("navbar.about_Us.testimonials")}
                        </NavLink>

                        <div className="relative group/Medias">
                          <NavLink to="#" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss`}>
                            {t("navbar.news_sub.media")}
                            <RiArrowDropRightLine className="text-lg" />
                          </NavLink>
                          <div className="absolute left-full top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/Medias:opacity-100 group-hover/Medias:visible transition duration-300">
                            <NavLink to="/actualites/media/presse" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 hover_miss`}>
                              {t("navbar.news_sub.media_sub.press")}
                            </NavLink>
                            <NavLink to="/actualites/media/blog" className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss`}>
                              {t("navbar.news_sub.media_sub.blog")}
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </div>
            </ul>
            <div className="flex flex-col items-end gap-2">
              <div className="flex items-center justify-end gap-4 pb-3 pt-4">
                <p className="flex items-center gap-1 cursor-pointer hover:opacity-50" onClick={() => changeLanguage("fr")}>
                  <img width={20} src={images.france_logo} alt="" />
                  <span className="text-white font-semibold">Francais</span>
                </p>
                <p className="flex items-center gap-1 cursor-pointer hover:opacity-50" onClick={() => changeLanguage("en")}>
                  <img width={20} src={images.usa_logo} alt="" />
                  <span className="text-white font-semibold">English</span>
                </p>
                {!localStorageUser ? (
                  <div>
                    <NavLink to="/login">
                      <button className="font-bold hover:opacity-75 text-white bg-[#00573f] px-10 py-1 text-[18px] rounded-full">Login</button>
                    </NavLink>
                  </div>
                ) : (
                  <div>
                    <NavLink to="/membership/profile">
                      <button className="font-bold flex gap-2 items-center text-[#00573f] bg-white border border-[#00573f] px-6 py-1 text-[18px] rounded-full">
                        <BiUser className={`h-6 w-6 text-[#00573f] font-bold`} />
                        {language === "fr" ? "Mon profil" : "My profile"}
                      </button>
                    </NavLink>
                  </div>
                )}
              </div>
              <RolexClock style=" max-w-[25vw] shadow-[5px_3px_15px_rgba(0,0,0,0.4)] rounded-full h-[75px]" />
            </div>
          </div>
        </div>
      </div>
      */}



      {/* mobile menu */}
      <div
        className={`mobile-menu overflow-x-hidden custom:hidden ${
          mobileOpen ? "open" : ""
        }`}
      >
        <ul className="mobile-nav-links" ref={sidebarRef}>
          <li className="flex items-center justify-center mt-4">
            {user ? (
              <div className="flex op relative flex-col items-center gap-1 mt-4 mb-4">
                <div className="relative">
                  <img src={imagess} alt="" className="h-[98px]  w-[160px]" />
                  <img
                    src={profile ?? user?.photo}
                    alt=""
                    className="h-[98px] w-[100px] rounded-full absolute bottom-[4px] left-1/2 transform -translate-x-1/2"
                  />
                </div>

                <div className="flex flex-col items-center gap-[1rem]">
                  <p
                    className=" text-[20px] font-bold "
                    style={{
                      color: membership?.membership_packs?.color ?? "#00573f",
                    }}
                  >
                    {pack
                      ? pack?.name?.charAt(0).toUpperCase() +
                        pack?.name?.slice(1)
                      : "Free"}{" "}
                    <span className="text-[15px] text-white">
                      {t("sideBar.member2")}
                    </span>
                  </p>

                  {pack?.id !== 3 && (
                    <button
                      onClick={() => navigate("/membership/demande")}
                      className={`font-bold px-6 py-2 md:px-8 md:py-3 rounded-full text-sm md:text-base ${
                        membership?.membership_packs?.name === "golfer" ||
                        membership?.membership_packs?.name === "golfer+"
                          ? "text-black"
                          : " text-white"
                      }`}
                      style={{
                        backgroundColor: imagess22,
                      }}
                    >
                      Upgrade
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <NavLink to="/home">
                <img
                  className="w-[60px] h-[70px] overflow-visible"
                  src={images.gtm_rolex}
                  alt="Logo GTM"
                />
              </NavLink>
            )}
          </li>

          <li>
            <button
              type="button"
              className="dropdown-toggle"
              onClick={toggleGtmClub}
            >
              {t("navbar.gtmClub")}
              <RiArrowDropDownLine className="inline-block text-2xl" />
            </button>
            {openGtmClub && (
              <ul className="submenu">
                {/* 2026 Program hidden */}
                {/* <li>
                  <NavLink to="/GTMclub/calendar">
                    2026 National Golf Events
                  </NavLink>
                </li> */}

                {/* Membership hidden */}

                <li>
                  <NavLink to="/GTMclub/Golf&LinkingUp">
                    <button className="flex items-center justify-between w-full">
                      Business
                      <RiArrowDropDownLine className="inline-block text-2xl" />
                    </button>
                  </NavLink>
                  <ul className="submenu nested">
                    {/* <li>
                      <NavLink to="/networking/conference">
                        {t("navbar.gtm_Club.busines_sub.g_n")} 
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          Conferences
                        </div>
                      </NavLink>
                    </li> */}
                    {/* Moroccan Sunset hidden */}
                    {/* <li>
                      <a href="/GTMclub/business/cultures">
                        {t("navbar.gtm_Club.busines_sub.b_c")}
                      </a>
                    </li> */}
                    <li>
                      <NavLink to="/GTMclub/business/cultures">
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          {t("navbar.gtm_Club.busines_sub.b_c")}
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/GTMclub/strategies/2daySummit">
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          {t("navbar.gtm_Club.summit_sub.day_summit")}
                        </div>
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li>
                  <button type="button" className="dropdown-toggle">
                    {/* {t("navbar.gtm_Club.tournaments_sub.industry")} */}
                    Golf
                    <RiArrowDropDownLine className="inline-block text-2xl" />
                  </button>
                  <ul className="submenu nested">
                    <li>
                      <NavLink
                        to="/GTMclub/tournois/gtmIconic"
                        className="flex"
                      >
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          {t("navbar.gtm_Club.tournaments_sub.gtm_ionic")}
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/GTMclub/tournois/industry">
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          {t("navbar.gtm_Club.tournaments_sub.industry")}
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/GTMclub/tournois/Initiation">
                        {/* {t("navbar.gtm_Club.tournaments_sub.industry")} */}
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          Initiation
                        </div>
                      </NavLink>
                    </li>
                  </ul>
                </li>

                <li>
                  <button type="button" className="dropdown-toggle">
                    {/* {t("navbar.gtm_Club.summit")} */}
                    Lifestyle
                    <RiArrowDropDownLine className="inline-block text-2xl" />
                  </button>
                  <ul className="submenu nested">
                    <li>
                      <NavLink to="/lifestyle/arts">
                        {/* {t("navbar.gtm_Club.summit_sub.day_summit")} */}
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          Art
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/lifestyle/bigsmoke">
                        {/* {t("navbar.gtm_Club.summit_sub.day_summit")} */}
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          Big Smoke
                        </div>
                      </NavLink>
                    </li>
                           {/* Classic Cars hidden */}
                    <li>
                      <NavLink to="/lifestyle/rando-adventure">
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          Off-Road Adventure
                        </div>
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </ul>
            )}
          </li>

          {/* Trips hidden */}

          {/* Sponsoring hidden */}

          {/* Actualités hidden */}

          <li>
            <NavLink to="/gtmclub/2026program" className="block px-4 py-3 text-white font-semibold">
              {t("navbar.calendar")}
            </NavLink>
          </li>

          <li>
            <button
              type="button"
              className="dropdown-toggle"
              onClick={() => {
                setOpenApropos(!openApropos);
                // navigate("/apropos");
              }}
            >
              {t("navbar.aboutUs")}
              <RiArrowDropDownLine className="inline-block text-2xl" />
            </button>
            {openApropos && (
              <ul className="submenu">
                <li>
                  <NavLink to="/apropos#Mission">
                    {t("navbar.about_Us.mission")}
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/apropos#Temoignages">
                    {t("navbar.about_Us.testimonials")}
                  </NavLink>
                </li>
                <li>
                  <button
                    type="button"
                    className="dropdown-toggle"
                    onClick={() => setOpenMedia(!openMedia)}
                  >
                    {t("navbar.news_sub.media")}
                    <RiArrowDropDownLine className="inline-block text-2xl" />
                  </button>
                  {openMedia && (
                    <ul className="submenu">
                      <li>
                        <button type="button" className="dropdown-toggle">
                          {t("navbar.news_sub.media_sub.press")}
                          <RiArrowDropDownLine className="inline-block text-2xl" />
                        </button>
                        <ul className="submenu nested">
                          <li>
                            <NavLink to="/actualites/media/presse#Written">
                              <div className="flex items-center gap-2">
                                <IoMdArrowDropright />
                                {t(
                                  "navbar.news_sub.media_sub.press_sub.written"
                                )}
                              </div>
                            </NavLink>
                          </li>
                          <li>
                            <NavLink to="/actualites/media/presse#Audiovisual">
                              <div className="flex items-center gap-2">
                                <IoMdArrowDropright />
                                {t("navbar.news_sub.media_sub.press_sub.audio")}
                              </div>
                            </NavLink>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <NavLink to="/actualites/media/blog">
                          {t("navbar.news_sub.media_sub.blog")}
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                {/* <li>
                  <a href="/apropos/gallery">
                    Gallery
                  </a>
                </li> */}
              </ul>
            )}
          </li>
        </ul>
        <div className=" flex flex-col    gap-10 pr-[12rem] pb-3 pt-5 pl-4">
          <div className="flex items-center gap-10">
            <button
              className="flex items-center gap-1 cursor-pointer hover:opacity-50"
              onClick={() => i18n.changeLanguage("fr")}
            >
              <img width={20} src={images.france_logo} alt="" />
              <span className="text-white font-semibold">Francais</span>
            </button>
            <button
              className="flex items-center gap-1 cursor-pointer hover:opacity-50"
              onClick={() => i18n.changeLanguage("en")}
            >
              <img width={20} src={images.usa_logo} alt="" />
              <span className="text-white font-semibold">English</span>
            </button>
          </div>
          <div>
            {!localStorageUser ? (
              <NavLink to="/login">
                <button className="font-bold text-white bg-[#00573f] px-10 py-1 text-[18px] rounded-full">
                  Login
                </button>
              </NavLink>
            ) : (
              <div>
                <div>
                  <NavLink to="/membership/profile">
                    <button className="font-bold flex  gap-2 items-center text-[#00573f] bg-white border border-[#00573f] px-10 py-2 text-[15px] rounded-full w-[12rem]">
                      <BiUser
                        className={`h-6 w-6 text-[#00573f] font-bold  `}
                      />
                      {t("sideBar.my_profile")}
                    </button>
                  </NavLink>
                </div>

                <div className="flex items-center justify-start mt-[2.5rem] text-white w-[20rem]  font-bold gap-2 cursor-pointer hover:text-[#ff0000] group">
                  <FiLogOut className="h-6 text-white w-6 group-hover:text-[#ff0000]" />
                  <button
                    className="text-white text-[15px] group-hover:text-[#ff0000]"
                    onClick={logout}
                  >
                    Se déconnecter
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};
